import { createSlice } from '@reduxjs/toolkit';
import { message } from 'antd';
import {
  makeFetchFailedActionType,
  makeFetchSuccessActionType,
} from '../../event/fetchActionTypeProvider';
import * as AllActions from '../action';
import ActionType from '../actionType';
import {
  CockpitStatus,
  CockpitType,
  CockpitMode,
  AcceptIssueStatus,
} from '@/utils/constant';

const initCurrentCockpit = {
  cockpitNumber: '',
  teamTotalNum: 0,
  teamPendingNum: 0,
  cockpitTeamNumber: '',
  cockpitTeamName: '',
  individualTotalNum: 0,
  individualWorkTime: 0, // 时间戳
  individualStartTime: 0, // 时间戳
};

const initialState: any = {
  mqttState: 'NOT_CONNECT',
  cockpitMode: CockpitMode.MONITOR,
  cockpitStatus: CockpitStatus.OFFLINE,
  acceptIssueStatus: AcceptIssueStatus.ACCEPT,
  lastCockpitNumber: '',
  currentCockpit: initCurrentCockpit,
  monitorCockpitList: [],
  cockpitCockpitList: [],
  mqttToken: null,
  cockpitTeamNumber: null,
};

const cockpitInfoState = createSlice({
  name: 'cockpitInfo',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(ActionType.MQTT_CONNECT_OK, (state, action: any) => {
        state.mqttState = 'CONNECT';
      })
      .addCase(ActionType.COCKPIT_TEAM_INFO, (state, action: any) => {
        const { payload } = action;
        state.currentCockpit.cockpitTeamName = payload.cockpitTeamName;
        state.currentCockpit.cockpitTeamNumber = payload.cockpitTeamNumber;
        state.currentCockpit.teamTotalNum = payload.completeIssueCount;
        state.currentCockpit.teamPendingNum = payload.waitAcceptIssueCount;
        const _cockpitCockpitList: any[] = [];
        const _monitorCockpitList: any[] = [];
        payload.cockpitList?.forEach((val: any) => {
          if (val.cockpitType === CockpitType.COCKPIT_SEAT) {
            _cockpitCockpitList.push(val);
          } else if (val.cockpitType === CockpitType.MONITOR_SEAT) {
            _monitorCockpitList.push(val);
          }
        });
        state.monitorCockpitList = _monitorCockpitList;
        state.cockpitCockpitList = _cockpitCockpitList;
      })
      .addCase(ActionType.COCKPIT_USER_INFO, (state, action: any) => {
        const { payload } = action;
        if (payload.cockpitType !== CockpitType.COCKPIT_SEAT) {
          state.currentCockpit.individualWorkTime =
            payload?.workTimeTotal * 1000;
          state.currentCockpit.individualStartTime = payload.workStartTime
            ? new Date(payload?.workStartTime).getTime()
            : null;
          state.currentCockpit.individualTotalNum = payload?.completeIssueCount;
          state.cockpitStatus = payload.cockpitStatus ?? CockpitStatus.OFFLINE;
          state.cockpitMode = payload.cockpitMode ?? CockpitMode.MONITOR;
          state.acceptIssueStatus =
            payload.acceptIssueStatus ?? AcceptIssueStatus.ACCEPT;
          state.lastCockpitNumber = payload.lastCockpitNumber;
          state.currentCockpit.cockpitNumber = payload?.cockpitNumber;
        }
      })
      .addCase(
        makeFetchSuccessActionType(ActionType.CHANGE_COCKPIT_MODE_STATUS),
        (state, action: any) => {
          const { payload } = action;
          if (payload.data) {
            if (
              payload?.data.cockpitMode &&
              payload.data.cockpitType === CockpitType.MONITOR_SEAT
            ) {
              state.cockpitMode = payload?.data.cockpitMode;
            }
            if (
              payload?.data.cockpitStatus &&
              payload.data.cockpitType === CockpitType.MONITOR_SEAT
            ) {
              state.cockpitStatus = payload.data.cockpitStatus;
            }
            if (payload?.data.cockpitTeamNumber) {
              state.cockpitTeamNumber = payload.data.cockpitTeamNumber;
            }
          }
        },
      )
      .addCase(ActionType.CLEAR_COCKPIT_INFO, (state, action: any) => {
        state.cockpitMode = CockpitMode.MONITOR;
        state.cockpitStatus = CockpitStatus.OFFLINE;
        state.monitorCockpitList = [];
        state.cockpitCockpitList = [];
        state.currentCockpit = initCurrentCockpit;
      })
      .addCase(
        makeFetchSuccessActionType(ActionType.GET_MQTT_TOKEN),
        (state, action: any) => {
          const res = action.payload;
          state.mqttToken = res.data && res.data?.accessToken;
        },
      );
  },
});

export default cockpitInfoState.reducer;
